export enum PresenceState {
	Online = "Online",
	Available = "Available",
	AvailableIdle = "AvailableIdle",
	Busy = "Busy",
	BusyIdle = "BusyIdle",
	DND = "DoNotDisturb",
	BeRightBack = "BeRightBack",
	Away = "Away",
	Offline = "Offline",
	PresenceUnknown = "PresenceUnknown",
}
